var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({attrs:{"remote":"","reserve-keyword":"","filterable":"","placeholder":_vm.$t('pleaseEnter'),"remote-method":v => {
      _vm.$utils.debounce(_vm.remoteMethod, 1000)(v)
    }},on:{"change":_vm.changeEvent},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}},'el-select',_vm.$attrs,false),_vm._l((_vm.list),function(a){return _c('el-option',{key:a.spId,attrs:{"value":a.spId,"label":a.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }